import { CommonModule } from '@angular/common';
import { AfterViewInit, Component, Input, OnInit } from '@angular/core';

//import { ToastrService } from 'ngx-toastr';
import { ClientShowModel } from 'src/app/core/models/client-show.model';
import { environment } from 'src/environments/environment';
import { MdbModalService } from 'src/lib/mdb5-adapted/public-api';

import { ClientNotesComponent } from './client-notes/client-notes.component';
import { ClientnoteService } from './clientnote.service';

@Component({
  selector: 'app-client-header',
  templateUrl: './client-header.component.html',
  styleUrls: ['./client-header.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
  ]
})
export class ClientHeaderComponent implements OnInit, AfterViewInit {
  isNotesShowing = environment.showClientNotes || false;

  @Input() clientDetails?: ClientShowModel;

  @Input() showQuote? = false;

  clientNotes: any;
  notesCount = 0;

  constructor(
    private clientNoteService: ClientnoteService,
    public modalService: MdbModalService) { }

  ngOnInit(): void {
    // Defensive: some shallow unit tests instantiate this component without
    // providing `clientDetails` as an input. Guard access to avoid runtime
    // template/constructor errors during tests.
    if (!this.isNotesShowing || !this.clientDetails) {
      return;
    }

    const cid = this.clientDetails.clientId;
    if (cid) {
      this.clientNoteService.getClientNotes(cid).subscribe((cnote: any) => {
        this.notesCount = cnote?.length || 0;
        //this.clientNoteCount.emit(cnote.length);
      });
    }
  }


  ngAfterViewInit() {
  }

  openNoteDialog() {
    if (this.clientDetails && this.clientDetails.clientId) {
      this.modalService.open(ClientNotesComponent, {
        modalClass: 'modal-md modal-dialog-centered',
      containerClass: 'container-fluid',
      backdrop: true,
      ignoreBackdropClick: true,
      keyboard: true,
      data: {
          clientid: this.clientDetails.clientId,
          existingNotes: this.clientNotes
        }
      }).onClose.subscribe(result => {
        this.notesCount = result || 0;
      });
    }
  }
}
